<script>
export default {
	name: 'Tnc-Sidebar',
	functional: true,
	props: {
		items: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		listGenerator(items) {
			return (
				<ul>
					{items.map(item => {
						let children;

						if (item.children) children = this.listGenerator(item.children);

						return (
							<li>
								<a
									href="javascript:void(0)"
									name={item.href}
									onClick={() => this.$emit('sidebarClick', item.href)}
								>
									<span>{this.$t(item.title)}</span>
								</a>
								{children}
							</li>
						);
					})}
				</ul>
			);
		},
	},
	render() {
		return this.listGenerator(this.items);
	},
};
</script>
